/* eslint eslint-comments/no-use: off */
/* eslint-disable @github-ui/github-components/require-component-stories */
import {Box, Link} from '@primer/react'

export function CodeViewFooter() {
  return (
    <>
      <Box
        sx={{
          mt: 2,
          mx: 3,
          mb: '12px',
          fontSize: 0,
          alignItems: 'center',
        }}
      >
        <Link
          href="https://docs.github.com/repositories/working-with-files/using-files/navigating-code-on-github"
          target="_blank"
        >
          Documentation
        </Link>
        &nbsp;&bull;&nbsp;
        <Link href="https://github.com/orgs/community/discussions/54546" target="_blank">
          Share feedback
        </Link>
      </Box>
    </>
  )
}

try{ CodeViewFooter.displayName ||= 'CodeViewFooter' } catch {}